<ng-container [formGroup]="form">
  <div class="c-form__section">
    <p500-ui-textarea-field formControlName="question" i18n-label="@@common.question" label="Question"></p500-ui-textarea-field>
  </div>
  <div class="c-form__section">
    <p500-ui-select-field
      formControlName="type"
      [data]="types"
      i18n-label="@@common.type"
      label="Type"
      (ngModelChange)="typeChange($event)"
    ></p500-ui-select-field>
  </div>
  <div class="c-form-field c-form-field--d">
    <div class="d-flex">
      <span class="c-form-field__label mr-6" i18n="@@common.add_answer">Add Answer</span>
      <button
        type="button"
        p500-ui-circled-button
        size="small"
        color="primary"
        (click)="addForm()"
        [disabled]="!form.controls.type.value || disabledAddControlButton"
        class="c-form-field__add-icon"
      >
        <p500-ui-icon name="plus"></p500-ui-icon>
      </button>
    </div>
  </div>
  <ng-container *ngFor="let control of form.controls.answers.controls; index as i">
    <div class="c-form__section">
      <p500-ui-text-field [formControl]="control">
        <ng-template p500UIFieldLabel>
          <div class="d-flex">
            <div class="p500-ui-form-field__label"><span i18n="@@common.answer">Answer</span> #{{ i + 1 }}</div>
            <button
              p500-ui-confluent-button
              color="warn"
              size="small"
              type="button"
              (click)="removeForm(i)"
              class="ml-10"
              i18n="@@common.remove"
            >
              Remove
            </button>
          </div>
        </ng-template>
      </p500-ui-text-field>
    </div>
  </ng-container>
</ng-container>
